"use strict";
import React from 'react';
import CountUp from 'react-countup';
function numberFormatter(num) {
    return <CountUp end={Math.sign(num) * Math.abs(num)} duration={2} />
    //return Math.abs(num) > 9999999 ?
    //     Math.sign(num) * ((Math.abs(num) / 10000000).toFixed(1)) + 'Cr' :
    //     Math.abs(num) > 99999 ?
    //         Math.sign(num) * ((Math.abs(num) / 100000).toFixed(1)) + 'Lac' :
    //         Math.abs(num) > 999 ?
    //             Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' :
    //<CountUp end={Math.sign(num) * Math.abs(num)} duration={5} />

}

export default numberFormatter;
